import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';

import { apiClient } from 'api/apiClient';
import type { IRequestException } from 'api/types/requestException';

export interface IStripeProduct {
    priceId: string;
    count?: number;
    productEnum?: string;
}

export interface IMultipleInput {
    data: IStripeProduct[];
    platform: string;
    state?: string;
    zip?: string;
}

interface ISelectSubscriptionResponse {
    redirectUrl: string;
}

const selectSubscriptionMultiple = async ({
    data,
    platform,
    zip,
    state,
}: IMultipleInput) => {
    const response = await apiClient.post('subscriptions-multiple', {
        json: {
            data,
            platform,
            zip,
            state,
        },
        headers: {
            'Content-Type': 'application/json',
        },
    });

    return (await response.json()) as ISelectSubscriptionResponse;
};

// eslint-disable-next-line id-length
export const useSelectSubscriptionMultipleMutation = (
    options: UseMutationOptions<
        ISelectSubscriptionResponse,
        IRequestException,
        IMultipleInput
    >
) => {
    return useMutation(
        async (props) => await selectSubscriptionMultiple(props),
        options
    );
};
